import script from "./workloadsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./workloadsTable.vue?vue&type=script&setup=true&lang=ts"

import "./workloadsTable.vue?vue&type=style&index=0&id=693fc703&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-693fc703"]])

export default __exports__